import { signal, computed } from "@preact/signals";
import type { Index } from "./lib/planner";
import { resolve, analyse } from "./lib/planner";
import { active } from "./lib/state";
import type { Term } from "./lib/types";

export const idx = signal<Index | null>(null);
export const drawerId = signal<string | null>(null);
export const toast = signal<string | null>(null);
export const planTerm = signal<Term>(active.value.term || "winter");

export const resolved = computed(() => (idx.value ? resolve(idx.value, active.value, planTerm.value) : { slots: [], auto: [], warnings: [] }));
export const analysis = computed(() => (idx.value ? analyse(resolved.value.slots, idx.value.units) : { clashes: [], transfers: [], clashIds: new Set<string>() }));

export function flash(msg: string) { toast.value = msg; setTimeout(() => { if (toast.value === msg) toast.value = null; }, 1800); }

const BASE: Record<string, string> = { ETF: "#2438e8", FF: "#9c1f33", EFSA: "#17684a" };
const EXTRA = ["#c26a00", "#6b2fb3", "#00838f", "#b0306a", "#5a6b00", "#8a4b2a", "#3d5a80", "#d1495b", "#2a9d8f", "#7a4fa0", "#a35d00", "#2f6f8f", "#8f2f5a", "#4f7a28", "#b04a2a", "#355c7d", "#6c5b7b", "#99582a", "#1d7874", "#7d3c98", "#a0522d", "#2e86ab"];
export function unitColor(code: string): string {
  if (BASE[code]) return BASE[code];
  const codes = idx.value?.core.units.map((u) => u.code).filter((c) => !BASE[c]) ?? [];
  const i = codes.indexOf(code);
  return EXTRA[(i < 0 ? code.length : i) % EXTRA.length];
}
